
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinbhosari() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services in Bhosari MIDC',
        heading: 'etravo :  Corporate Cab and Bus Services in Bhosari MIDC',
        headingDescription: 'eTravo delivers efficient and dependable Corporate Cab and Bus Services in Bhosari MIDC, tailored specifically for industrial and business zones. Serving manufacturing units, IT parks, and corporate offices, we provide executive cabs for business meetings and client visits, along with high-capacity buses for daily employee transportation. Our fleet is maintained to professional standards with features like GPS tracking, comfortable seating, and experienced drivers. Choose eTravo in Bhosari MIDC for streamlined, safe, and punctual transportation solutions that support your corporate productivity.',

        top: 'Top Places to Visit in Bhosari with etravo',
  "topPlaces": [
    {
      "title": "Marutrao Landge International Wrestling Complex",
      "description": "Established in 2023, this state-of-the-art facility underscores Bhosari's rich wrestling heritage. It serves as a premier training center for aspiring wrestlers and hosts various national and international wrestling events."
    },
    {
      "title": "Ankushrao Landage Natyagruha",
      "description": "A prominent cultural auditorium in Bhosari, it hosts a variety of events including plays, musical performances, and community gatherings, reflecting the local cultural vibrancy."
    },
    {
      "title": "Annabhau Udyan",
      "description": "A well-maintained park offering lush greenery, walking trails, and play areas, making it a favorite spot for families and fitness enthusiasts seeking relaxation amidst nature."
    },
    {
      "title": "Bhosari Sahal Kendra Udyan",
      "description": "This recreational park provides open spaces for sports and leisure activities, catering to visitors of all ages looking for outdoor enjoyment."
    },
    {
      "title": "Gangotri Park Garden",
      "description": "A serene garden known for its landscaped lawns and peaceful ambiance, ideal for morning walks and unwinding in a tranquil environment."
    },
    {
      "title": "Nana Nani Park",
      "description": "Specifically designed for senior citizens, this park offers comfortable seating, shaded areas, and a calm atmosphere for relaxation and social interaction."
    },
    {
      "title": "Moshi Traffic Park",
      "description": "An educational park aimed at teaching children about road safety through interactive exhibits and miniature traffic setups, promoting awareness in a fun manner."
    },
    {
      "title": "Spine City Mall",
      "description": "A shopping destination featuring a variety of retail outlets, eateries, and entertainment options, providing a comprehensive shopping experience for visitors."
    },
    {
      "title": "Deluxe Fortune Mall",
      "description": "A modern mall offering a mix of shopping, dining, and entertainment facilities, catering to the diverse needs of shoppers and families."
    },
    {
      "title": "Morya Gosavi Ganpati Mandir",
      "description": "Located nearby in Chinchwad, this historic temple is dedicated to Lord Ganesha and is a significant pilgrimage site, attracting devotees from across the region."
    }
  ],
   "services": [
    {
      "name": "Corporate Transport in Bhosari MIDC",
      "description": "eTravo delivers reliable and efficient corporate transport services in Bhosari MIDC, catering specifically to industrial zones and manufacturing hubs. We provide daily pick-up and drop solutions for factory workers, administrative staff, and executives. Our transport services are built around punctuality, route optimization, and safety, ensuring smooth operations for businesses of all sizes in this industrial corridor."
    },
    {
      "name": "Cab & Bus Services for Industries in Bhosari",
      "description": "eTravo offers flexible cab and bus services for industries operating in Bhosari. Whether you need daily employee transport, project-based mobility, or executive transfers, we have a well-maintained fleet of AC cabs, tempo travellers, and buses to match your specific business requirements. Our services ensure compliance, reliability, and professionalism in every ride."
    },
    {
      "name": "Employee Shuttle Bus in Bhosari MIDC",
      "description": "Our dedicated employee shuttle bus service in Bhosari MIDC is ideal for transporting large teams across shifts. eTravo designs route-based and time-specific shuttle plans for factories, warehouses, and IT parks. With GPS tracking, safety protocols, and a strong support system, our shuttles guarantee a secure and hassle-free commute for industrial workforces."
    },
    {
      "name": "Staff Commute Services for MIDC Units",
      "description": "eTravo provides end-to-end staff commute services tailored for MIDC units in Bhosari. We offer dedicated vehicle options to manage the transport needs of employees across shifts and locations. With reliable scheduling, real-time monitoring, and responsive customer service, we help businesses ensure their workforce travels safely and efficiently every day."
    },
    {
      "name": "Reliable Corporate Bus Rentals in Bhosari",
      "description": "eTravo's corporate bus rental services in Bhosari are perfect for industries needing scalable transport for staff or special corporate events. Our fleet includes AC and non-AC buses, ranging from 20-seaters to 50-seaters, ideal for regular commuting or temporary deployment. We focus on safety, comfort, and time adherence to meet industrial transport expectations."
    },
    {
      "name": "AC Cab & Bus Hire for Corporate Offices in Bhosari MIDC",
      "description": "Looking for premium corporate transport options in Bhosari MIDC? eTravo provides AC cabs and buses for offices, R&D centers, and corporate units. Ideal for executives, clients, and senior staff, our vehicles ensure a comfortable and professional ride experience. Book single trips, round trips, or regular schedules—all managed with precision and care."
    },
    {
      "name": "Office Transport Services Bhosari",
      "description": "eTravo’s office transport services in Bhosari are designed for daily employee movement within the industrial area and nearby residential zones. We offer customized transport plans using a mix of cabs, vans, and buses. Our services are managed with live tracking, automated scheduling, and responsive customer care to ensure smooth corporate mobility across departments."
    }
  ],
  "tableData": [
    ["Corporate Transport in Bhosari MIDC", "Cab & Bus Services for Industries in Bhosari"],
    ["Employee Shuttle Bus in Bhosari MIDC", "Staff Commute Services for MIDC Units"],
    ["Reliable Corporate Bus Rentals in Bhosari", "AC Cab & Bus Hire for Corporate Offices in Bhosari MIDC"],
    ["Office Transport Services Bhosari", ""]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Efficient and On-Time Transportation in Bhosari MIDC",
        "WhyChoosedescription": "Located in one of Pune’s busiest industrial zones, Bhosari MIDC demands punctual and well-coordinated transport. At eTravo, we specialize in time-bound corporate cab and bus services that help manufacturing units, tech parks, and offices move employees and guests efficiently—ensuring zero downtime and optimized daily operations."
    },
    {
        "WhyChooseheading": "Fleet Tailored for Industrial and Corporate Needs",
        "WhyChoosedescription": "Whether you need air-conditioned cabs for executives or large buses for factory shifts, eTravo offers a robust and diverse fleet to support your corporate travel requirements in Bhosari MIDC. All our vehicles are maintained to industrial standards and come with ample space, clean interiors, and comfortable seating for hassle-free daily or occasional travel."
    },
    {
        "WhyChooseheading": "Professional Drivers Familiar with MIDC Routes",
        "WhyChoosedescription": "Our drivers are not only professionally trained but also highly familiar with Bhosari MIDC’s route complexities, shift change timings, and security gate procedures. Their local knowledge helps streamline movement within the industrial area while maintaining the professional standards expected in corporate travel."
    },
    {
        "WhyChooseheading": "Transparent and Industrial-Friendly Pricing",
        "WhyChoosedescription": "We provide upfront, contract-friendly pricing with no hidden charges. Whether it's for daily shuttles, shift-based schedules, or temporary deployments, eTravo gives you clarity and affordability—ideal for businesses managing transport at scale within Bhosari MIDC."
    },
    {
        "WhyChooseheading": "High Safety Standards and Well-Maintained Vehicles",
        "WhyChoosedescription": "Safety is critical when transporting large teams across industrial zones. Our vehicles are equipped with GPS tracking, first-aid kits, seat belts, fire extinguishers, and are sanitized regularly. eTravo ensures every journey is not just smooth, but secure—meeting both employee expectations and compliance standards."
    },
    {
        "WhyChooseheading": "24/7 Support for Shift-Based Operations",
        "WhyChoosedescription": "Bhosari MIDC operates beyond standard hours—and so do we. eTravo offers round-the-clock transport and live support to accommodate businesses with rotating shifts, night operations, or urgent logistics needs. Our team is always available for coordination, route changes, and emergency requests."
    },
    {
        "WhyChooseheading": "Quick Booking and Centralized Scheduling",
        "WhyChoosedescription": "We make transport management easy with a streamlined booking system. HR teams and transport coordinators in Bhosari MIDC can schedule daily or weekly rides, monitor vehicle movement, and modify plans instantly through our web portal or dedicated support line."
    },
    {
        "WhyChooseheading": "Custom Transport Solutions for Industrial Corporates",
        "WhyChoosedescription": "Every company in Bhosari MIDC has unique operational patterns. eTravo offers fully customizable corporate cab and bus services—from fixed-route employee pickups to on-demand executive rides and outstation logistics. Share your requirements, and we’ll design a transport solution that supports your workforce and business goals perfectly."
    }
]
























    }


   
// Corporate Cab and Bus Services in Bhosari MIDC – eTravo

const faqData = [
    [
        {
            question: 'What types of corporate transport services does eTravo offer in Bhosari MIDC?',
            answer: 'eTravo offers structured cab and bus services in Bhosari MIDC for corporate clients, including employee shifts, executive travel, and industrial workforce mobility across multiple shifts and routes.',
        },
        {
            question: 'Can eTravo manage shift-based employee transportation for manufacturing units?',
            answer: 'Yes, we specialize in shift-based transport logistics for industrial zones like Bhosari MIDC. We customize pickup and drop schedules based on your operational timings, including night shifts and staggered shifts.',
        },
        {
            question: 'What kind of vehicles are available for industrial and corporate clients in Bhosari MIDC?',
            answer: 'Our fleet includes executive sedans, hatchbacks for compact travel, tempo travellers, and AC buses with seating for 20 to 50 passengers — all maintained to meet industrial safety and comfort standards.',
        },
        {
            question: 'Does eTravo offer real-time tracking and safety compliance for corporate fleets?',
            answer: 'Yes, our vehicles are GPS-enabled, and we provide centralized dashboards with real-time tracking, route optimization, driver details, and automated reports to ensure complete operational transparency.',
        },
        {
            question: 'Can we hire eTravo for factory visits, audits, or vendor meetings from Bhosari MIDC?',
            answer: 'Absolutely. We provide on-demand and scheduled transport for business visits, audits, and corporate meetings across Pune or outstation, with professional service and vehicle readiness guaranteed.',
        },
        {
            question: 'Is there dedicated support for managing our Bhosari MIDC transport operations?',
            answer: 'Yes, eTravo assigns a dedicated account manager to each client in Bhosari MIDC to handle route planning, fleet coordination, daily support, and monthly reporting efficiently.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Mahesh Thombre',
        designation: 'Admin Supervisor, Technocast Industries',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has made managing our shift transport in Bhosari MIDC simple and dependable. Their buses are always on time and well-maintained, even for night shifts.”',
    },
    {
        name: 'Ms. Anuja Kadam',
        designation: 'HR Executive, IndoMek Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for daily employee commutes and VIP visits. Their support for industrial clients in Bhosari MIDC is outstanding — from route planning to safety compliance.”',
    },
];






















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Bhosari MIDC",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-bhosari-midc.jpg",
  "description": "Reliable corporate cab and bus services in Bhosari MIDC by eTravo. Perfect for employee shuttle, staff commute, and corporate transport solutions for industries and offices in Bhosari MIDC. Affordable AC vehicles with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2635"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-bhosari-midc"
  }
};




    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Services in Bhosari MIDC | Employee Shuttle & Office Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Bhosari MIDC with eTravo for reliable staff commute, employee shuttle, and corporate transport. Affordable AC cabs and buses with professional drivers." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/10.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinbhosari;